import { Link } from "react-router-dom";
import { Column, Grid, IconButton } from "@carbon/react";

import bannerIcon from "../../assets/icons/bank.svg";
import { SwitchAppButton } from "../SwitchAppButton";
import { Portal } from "../Portal";
import { CaretLeft } from "@carbon/icons-react";
import closeIcon from "../../assets/icons/close.svg";

export const View = ({
  title,
  subtitle,
  iframeUrlTarget,
  icon = bannerIcon,
  handleShowLoanAppInIframe,
  isLoanAppLoaded,
  showLoanAppDashboard,
  toggleShowLoanAppDashboard,
  hideBanner,
  handleHideBanner,
}) => {
  const returnButtonContainerClassName = `return-to-switchapp--button ${
    showLoanAppDashboard ? "loanapp" : "switchapp"
  }-dash`;

  return (
    <>
      {hideBanner ? null : (
        <div className={`flex-container loan-offer-available mt-5`}>
          <SwitchAppButton
            size="sm"
            kind="success"
            // variant="outline"
            className="flex-container flex-box pt-5 pb-5"
            containerClassName="flex-container flex-box activation-required--message"
            onClick={handleShowLoanAppInIframe}
          >
            <div className="activation-required--icon mr-5">
              <img src={icon} alt="bank icon" className="warning-icon" />
            </div>

            <div className="flex-box">
              <h3 className="activation-required--title font-ctm--bold">
                <strong>{title}</strong>
              </h3>

              <p className="activation-required--subtitle text-warning font-ctm--black">
                {subtitle}
              </p>
            </div>
          </SwitchAppButton>

          <div
            title="Close Banner"
            className="close-button--container close-loan-banner-button--container"
            onClick={(e) => {
              e.preventDefault();
              handleHideBanner();
            }}
          >
            <img src={closeIcon} alt="close button" className="close-icon" />

            {/*<IconButton
            label="Close"
            size="sm"
            kind="danger"
            className="close-button close-loan-banner-button p-0"
            onClick={handleHideBanner}
          >
            <img src={closeIcon} alt="close icon" className="close-icon" />
          </IconButton>*/}
          </div>
        </div>
      )}

      {!isLoanAppLoaded ? null : (
        <Portal className={returnButtonContainerClassName}>
          <SwitchAppButton
            size="xs"
            kind={showLoanAppDashboard ? "danger" : "success"}
            onClick={toggleShowLoanAppDashboard}
          >
            {showLoanAppDashboard ? (
              <img
                src={"/switchapp-logo.png"}
                alt="bank icon"
                className="warning-icon mr-3"
                width={30}
              />
            ) : (
              <img
                src={icon}
                alt="bank icon"
                className="warning-icon mr-3"
                width={30}
              />
            )}
            Return To {showLoanAppDashboard ? "SwitchApp" : "LoanApp"}
          </SwitchAppButton>
        </Portal>
      )}

      <div
        className={`loanapp-iframe-container ${
          !showLoanAppDashboard ? "hidden" : ""
        }`}
      >
        <iframe
          src={iframeUrlTarget + "/dashboard"}
          className="loanapp-iframe"
          title="switchapp loans dashboard"
        />
      </div>
    </>
  );
};
